export const iconFontAwesomeFilmVideoFileAudio = (
	<i className="fa-solid fa-file-audio"></i>
);
